import './styles/generic-config-details.scss'

import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

function GenericField({ valueKey, children }) {
  return (
    <div className="generic-field">
      <div className="key">{valueKey}</div>
      <div className="value">{children}</div>
    </div>
  )
}
GenericField.propTypes = {
  valueKey: PropTypes.string.isRequired,
  children: PropTypes.any,
}

export default class GenericConfigDetails extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    config: PropTypes.object.isRequired,
  }

  /**
   * Renders key value pairs and nested key value pairs
   */
  renderGenericFields = (keys, config) => {
    return keys.map((key) => {
      const value = config[key]
      if (value && Array.isArray(value)) {
        const asObject = {}
        value.forEach((obj) => {
          asObject[obj.key] = obj.value
        })
        return (
          <GenericField key={key} valueKey={key}>
            {this.renderGenericFields(Object.keys(asObject), asObject)}
          </GenericField>
        )
      } else if (value && typeof value === 'object')  {
        return (
          <GenericField key={key} valueKey={key}>
            {this.renderGenericFields(Object.keys(value), value)}
          </GenericField>
        )
      } else if (key === 'endpoint') {
        return (
          <GenericField key={key} valueKey={key}>
            <Link to={`/endpoints/item/${value}`}>{value}</Link>
          </GenericField>
        )
      } else {
        return (
          <GenericField key={key} valueKey={key}>{`${value}`}</GenericField>
        )
      }
    })
  }

  render() {
    const { title, config } = this.props
    const keysWithValues = Object.keys(config).filter((k) => config[k]).sort()

    if (!keysWithValues.length) {
      return null
    }

    return (
      <div className="generic-config-details">
        <div className="title">{title}</div>

        <div className="content">
          {this.renderGenericFields(keysWithValues, config)}
        </div>
      </div>
    )
  }
}
